import { attr, many } from 'redux-orm';
import Model from '../base-model';
import { userActions, forumUserActions } from './user.action';
import userReducers from './user.reducer';

/** 
 * User
 * @typedef {Object} User
 * @property {string} phoneNumber
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} email
 * @property {boolean} profileIsCompleted
 * @property {boolean} emailVerified
 * @property {Date} joinDate
 * @property {string} address
 * @property {string} biography
 * @property {Date} birthday
 * @property {string} educationDegree
 * @property {string} image
 * @property {string} linkedinUrl
 * @property {string} postalCode
 * @property {string} university
 */

export class User extends Model {
    
    get fullName() {
        return `${this.firstName} ${this.lastName}`
    }

    static reducer(action, Self, session) {
        switch (action.type) {
        case userActions.set:
            userReducers.set(session, action.user);
            break;
        case userActions.remove:
            userReducers.dump(session);
            break;
        case userActions.setAttachments:
            userReducers.setAttachments(session, action.attachments);
            break;
        case userActions.updateUserPicture:
            userReducers.updateUserPicture(session, action.image);
            break;
        case userActions.changeEmail:
            userReducers.changeEmail(session, action.email);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `User: ${this.phoneNumber}`
    }
}

User.modelName = 'User';

User.fields = {
    phoneNumber: attr(),
    firstName: attr(),
    lastName: attr(),
    email: attr(),
    profileIsCompleted: attr(),
    emailVerified: attr(),
    joinDate: attr(),
    attachments: many('Attachment'),
    address: attr(),
    major: attr(),
    biography: attr(),
    birthday: attr(),
    educationDegree: attr(),
    image: attr(),
    linkedinUrl: attr(),
    postalCode: attr(),
    university: attr(),
    jobTitle: attr(),
    jobPosition: attr(),
}

/**
 * ForumUser
 * @typedef {Object} ForumUser
 * @property {string} id
 * @property {string} fullName
 * @property {string} image
 * @property {string} role
 */

export class ForumUser extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
            case forumUserActions.create:
                userReducers.create(session, action.ForumUser);
                break;
            default:
                return undefined;
        }
    }
    toString() {
        return `Topic: ${this.fullName}`
    }
}

ForumUser.modelName = 'ForumUser';

ForumUser.fields = {
    id: attr(),
    fullName: attr(),
    image: attr(),
    role: attr(),
}
